import chartingProxy from '../../proxies/technical/Charting';
import ServiceBase from '../ServiceBase';

class ChartingService extends ServiceBase {
  getTradingViewData(params) {
    return this.processSubscription(data => {
      var res = [];

      res.push(this.getSubscribtionChannel(params.Code));

      return res;
    })(() => this.getData(() => chartingProxy.getTradingViewData(params)));
  }

  getStockEvents(params) {
    return chartingProxy.getStockEvents(params);
  }

  saveTemplate(data) {
    return chartingProxy.saveTemplate(data);
  }

  getTemplate() {
    return this.applyMemoryCache('Charting_GetTemplate')(() =>
      chartingProxy.getTemplate(),
    );
  }

  getIndicator(params) {
    return chartingProxy.getIndicator(params);
  }
}

const chartingService = new ChartingService();
export default chartingService;
